/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftMetadataAttribute } from './NftMetadataAttribute';
import {
    NftMetadataAttributeFromJSON,
    NftMetadataAttributeFromJSONTyped,
    NftMetadataAttributeToJSON,
    NftMetadataAttributeToJSONTyped,
} from './NftMetadataAttribute';
import type { EVMChain } from './EVMChain';
import {
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    EVMChainToJSONTyped,
} from './EVMChain';

/**
 * Represents metadata for a NFT.
 * @export
 * @interface NftMetadata
 */
export interface NftMetadata {
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftMetadata
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftMetadata
     */
    updatedAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftMetadata
     */
    tokenId: number;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    contractAddress: string;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    tokenUri?: string;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    tokenImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    tokenName?: string;
    /**
     * 
     * @type {string}
     * @memberof NftMetadata
     */
    tokenDescription?: string;
    /**
     * 
     * @type {EVMChain}
     * @memberof NftMetadata
     */
    evmChain?: EVMChain;
    /**
     * Traits/attributes/characteristics for each NFT asset.
     * @type {Array<NftMetadataAttribute>}
     * @memberof NftMetadata
     */
    attributes?: Array<NftMetadataAttribute>;
    /**
     * 
     * @type {boolean}
     * @memberof NftMetadata
     */
    isVirtual?: boolean;
}



/**
 * Check if a given object implements the NftMetadata interface.
 */
export function instanceOfNftMetadata(value: object): value is NftMetadata {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('tokenId' in value) || value['tokenId'] === undefined) return false;
    if (!('contractAddress' in value) || value['contractAddress'] === undefined) return false;
    return true;
}

export function NftMetadataFromJSON(json: any): NftMetadata {
    return NftMetadataFromJSONTyped(json, false);
}

export function NftMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'tokenId': json['tokenId'],
        'contractAddress': json['contractAddress'],
        'tokenUri': json['tokenUri'] == null ? undefined : json['tokenUri'],
        'tokenImageUrl': json['tokenImageUrl'] == null ? undefined : json['tokenImageUrl'],
        'tokenName': json['tokenName'] == null ? undefined : json['tokenName'],
        'tokenDescription': json['tokenDescription'] == null ? undefined : json['tokenDescription'],
        'evmChain': json['evmChain'] == null ? undefined : EVMChainFromJSON(json['evmChain']),
        'attributes': json['attributes'] == null ? undefined : ((json['attributes'] as Array<any>).map(NftMetadataAttributeFromJSON)),
        'isVirtual': json['isVirtual'] == null ? undefined : json['isVirtual'],
    };
}

export function NftMetadataToJSON(json: any): NftMetadata {
    return NftMetadataToJSONTyped(json, false);
}

export function NftMetadataToJSONTyped(value?: NftMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'tokenId': value['tokenId'],
        'contractAddress': value['contractAddress'],
        'tokenUri': value['tokenUri'],
        'tokenImageUrl': value['tokenImageUrl'],
        'tokenName': value['tokenName'],
        'tokenDescription': value['tokenDescription'],
        'evmChain': EVMChainToJSON(value['evmChain']),
        'attributes': value['attributes'] == null ? undefined : ((value['attributes'] as Array<any>).map(NftMetadataAttributeToJSON)),
        'isVirtual': value['isVirtual'],
    };
}

